/**
 * Builds the Workflow Builder link, passing the currently-selected subaccount as
 * an `organizationId` query param so WFB opens on that org rather than whatever
 * org was last stored locally in WFB (PAD-4755). Falls back to the bare link when
 * no organization is selected.
 *
 * Pass `workflowId` to deep-link to a single workflow rather than the list.
 */
export function buildWorkflowBuilderUrl(
  baseLink: string,
  organizationId?: string | null,
  workflowId?: string | null
): string {
  if (!organizationId && !workflowId) {
    return baseLink;
  }

  const url = new URL(baseLink);

  if (workflowId) {
    url.pathname = `${url.pathname.replace(/\/+$/, '')}/${workflowId}`;
  }

  if (organizationId) {
    url.searchParams.set('organizationId', organizationId);
  }

  return url.toString();
}
